<template>
  <div
    ref="container"
    :style="styles"
    :class="{ 'is-active': active }"
    class="LKToggleContainer"
  >
    <slot />
  </div>
</template>

<script>


const DEFAULT_DURATION = 0.2 // s

export default {
  name: 'LKToggleContainer',
  props: {
    active: Boolean,
  },
  data: () => ({
    styles: {},
  }),
  watch: {
    active: {
      handler() {
        this.setStyles()
      },
    },
  },
  mounted() {
    this.setStyles()
  },
  methods: {
    setStyles() {
      let height = 0
      const { children } = this.$refs.container
      let duration = (children.length + 1) / 100
      duration = Math.round((DEFAULT_DURATION + duration) * 100) / 100
      children.forEach((node) => {
        const computedStyle = getComputedStyle(node)
        height += (
          node.offsetHeight
          + parseInt(computedStyle.marginTop, 10)
          + parseInt(computedStyle.marginBottom, 10)
        )
      })

      this.styles = {
        transitionDuration: `${duration}s`,
        maxHeight: `${height}px`,
      }

      clearTimeout(this.timerId)
      const computedStyle = getComputedStyle(this.$el)
      const timeout = parseFloat(computedStyle.transitionDuration, 10)

      if (this.active) {
        this.timerId = setTimeout(() => {
          this.styles = { overflow: 'initial !important' }
        }, (timeout + duration) * 100)
      } else {
        this.timerId = setTimeout(() => {
          this.styles = {}
        }, (timeout + duration) * 100)
      }
    },
  },
}
</script>

<style lang="scss">

.LKToggleContainer {
  overflow: hidden;
  transition: all 0.25s;
  transition-timing-function: ease-in;

  &:not(.is-active) {
    max-height: 0;
  }
}
</style>
